export default __webpack_public_path__ + "static/media/mining.d2909087.jpg";